import React, {Fragment, useEffect, useState} from "react";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";
import {getOpsGenieTeams as onGetOpsGenieTeams} from "../../store/opsgenie/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Button, Card, CardBody, CardTitle, Col, Container, Row, Table} from "reactstrap";
import DocsTooltip from "components/Common/DocsTooltip";
import PropTypes from "prop-types";
import OpsGenieTeams from "../../store/opsgenie/reducer";
import {getOpsGenieRefresh} from "../../store/actions";
import Loader from "../../components/Loader/Loader";
import refreshResourcesLottie from "../../assets/images/refresh_resources_lottie.json";

const OpsGenie = props => {
  const dispatch = useDispatch();

  const {opsgenie_teams} = useSelector(state => ({
    opsgenie_teams: state.OpsGenieTeams.opsgenie_teams,
  }));
  const [opsgenieRefreshModal, setOpsgenieRefreshModal] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  useEffect(() => {
    dispatch(onGetOpsGenieTeams());
  }, [onGetOpsGenieTeams]);


  const handleClick = () => {
    dispatch(getOpsGenieRefresh());
    setOpsgenieRefreshModal(true);
    setTimeout(() => {
        setOpsgenieRefreshModal(false);
    }, 3000);
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Row>
            <Col lg="8">
              <div className="d-flex align-items-start gap-1">
                <Breadcrumbs
                  title={"OpsGenie Teams"}
                  breadcrumbItem={"OpsGenie Teams"}
                />
                <span> 
                  <i role="button"
                  className="bx bx-help-circle font-size-18 text-white" 
                  id="externalTooltip" />
                </span>
              </div>
              <DocsTooltip 
                placement={'right'}
                isOpen={tooltip}
                toggle={() => setTooltip(!tooltip)}
                targetId={'externalTooltip'}
                linkText={'External notifications?'}
                content={'Need help with'}
                link={'https://docs.temperstack.com/temperstack/getting-started/integrations-hub/external-notifications'}
              />
            </Col>
            <Col lg="4">
              <Button onClick={handleClick} color="primary" className="float-end">Rescan Opsgenie</Button>
            </Col>
          </Row>
          <Row>
                <div className="table-card">
                  <Table hover className="table-purple">
                    <thead className="table-light table-nowrap">
                    <tr>
                      <th>Name</th>
                      <th>OpsGenie ID</th>
                      <th>Created At</th>
                      <th>Refreshed At</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      opsgenie_teams.map((opsgenie_team, index) => (
                          <tr key={index}>
                            <td>{opsgenie_team.name}</td>
                            <td>{opsgenie_team.reference_id}</td>
                            <td>{opsgenie_team.created_at}</td>
                            <td>{opsgenie_team.updated_at}</td>
                          </tr>
                      ))
                    }
                    </tbody>
                  </Table>
                </div>
          </Row>
       </Container>
      </div>
      <Loader
          isOpen={opsgenieRefreshModal}
          lottieJson={refreshResourcesLottie}
          messageHeader="Scanning Opsgenie"
          message="Please wait while we scan your Opsgenie for new teams."
      />
    </React.Fragment>
  );
};

OpsGenie.propTypes = {
  t: PropTypes.any,
};

export default withRouter(OpsGenie);
